import { render } from "./PageItemDatabase.vue?vue&type=template&id=8b829c0c"
import script from "./PageItemDatabase.vue?vue&type=script&lang=js"
export * from "./PageItemDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__